import { render, staticRenderFns } from "./Trailer.vue?vue&type=template&id=23fadc2e&scoped=true&"
import script from "./Trailer.vue?vue&type=script&lang=js&"
export * from "./Trailer.vue?vue&type=script&lang=js&"
import style0 from "./Trailer.vue?vue&type=style&index=0&id=23fadc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fadc2e",
  null
  
)

export default component.exports